import { makeStyles } from '@material-ui/core';

export const useOptionStyles = makeStyles(() => ({ optionIcon }));

export const optionIcon = {
  height: '20px',
  width: '20px',
  marginRight: '1em',
};
